import type { RoomOptions } from 'livekit-client';

// LiveKit Cloud issues its own STUN/TURN credentials to each client over the
// signalling connection at join time, so we no longer advertise a self-hosted
// coturn here. Leaving iceServers unset lets the SDK use the cloud-provided
// relays (UDP, TCP, and TLS:443 fallback are all handled by LiveKit Cloud).
// iceTransportPolicy stays "all" so direct/reflexive paths are tried first.
export const RTC_CONFIG: RTCConfiguration = {
  iceTransportPolicy: 'all',
};

// Cap capture resolution at 360p across the app (ASL signing reads fine here
// and the bandwidth saving over 720p is significant).
const MAX_RESOLUTION = { width: 640, height: 360, frameRate: 30 } as const;

export const CALL_ROOM_OPTIONS: RoomOptions = {
  adaptiveStream: true,
  dynacast: true,
  videoCaptureDefaults: { resolution: MAX_RESOLUTION },
};

// The mirror Room in the loopback self-test must NOT pause the inbound stream
// when its <video> element looks "not visible" — our React effect attaches the
// track after TrackSubscribed fires, so adaptiveStream's IntersectionObserver
// can decide nobody's watching and stop the stream. Keep it off here.
export const LOOPBACK_MIRROR_ROOM_OPTIONS: RoomOptions = {
  adaptiveStream: false,
  dynacast: false,
};

/** Name of the 1:1 call room for a pair of users, from their auth **uuids**.
 *  Sorted so both clients derive the identical string from opposite argument
 *  order — that identity is what puts caller and callee in the same room. */
export function pairedRoomName(a: string, b: string): string {
  const [x, y] = [a, b].sort();
  return `aslgo-call-${x}-${y}`;
}
